import { useDispatch } from 'react-redux';
import { acceptGdpr } from 'core/userContext/actions';
import { Announcement } from 'ui/announcement/Announcement';
import { BUTTON_SIZES, SecondaryButton } from 'ui/button';
import { OpenNewWindow16 } from 'ui/icons/action/OpenNewWindow16';
import { DocumentationLink } from './Announcements.styled';

export const TEXT = {
  BUTTON: 'Accept',
  TEST_ID: 'gdpr-banner',
};

export const GdprAnnouncement = () => {
  const dispatch = useDispatch();

  return (
    <Announcement
      data-test={TEXT.TEST_ID}
      ActionButton={
        <SecondaryButton size={BUTTON_SIZES.SMALL} onClick={() => dispatch(acceptGdpr())}>
          {TEXT.BUTTON}
        </SecondaryButton>
      }
    >
      We have updated our{' '}
      <DocumentationLink href="https://iterable.com/privacy-policy/" target="_blank">
        Privacy Policy&nbsp;
        <OpenNewWindow16 isColorInherited={true} />
      </DocumentationLink>{' '}
      to provide increased clarity and comply with the new European Union General Data Protection
      Regulation (GDPR).
    </Announcement>
  );
};
